import script from "./contedo-helpdesk.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-helpdesk.vue?vue&type=script&setup=true&lang=js"

import "./contedo-helpdesk.vue?vue&type=style&index=0&id=5175cea0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5175cea0"]])

export default __exports__